import React from 'react';
import { useTranslation } from 'react-i18next';

import { preferenceActions } from '../../../actions';
import useDispatch from '../../../hooks/useDispatch';
import { usePreferences } from '../../../hooks/usePreferences';
import {
  DL_SWITCH_CLASS_NAME,
  DL_SWITCH_LINE_WRAPPER_CLASS_NAME,
  GENERAL_DL_SWITCH_CLASS,
} from '../PriceViewer';

const ConcentrationSwitch: React.FC<{
  wrapAnalytics: (dataKey: string, callback: () => void) => () => void;
}> = ({ wrapAnalytics }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { showTopN, priceViewerTopN, concentrationColorStyleV2 } =
    usePreferences();

  return (
    <div className={DL_SWITCH_LINE_WRAPPER_CLASS_NAME}>
      <div
        className={GENERAL_DL_SWITCH_CLASS + (showTopN ? ' checked' : '')}
        onClick={wrapAnalytics('topN', () =>
          dispatch(preferenceActions.setShowTopN(!showTopN))
        )}
        style={{ color: concentrationColorStyleV2, fontWeight: 700 }}
      >
        <div>{t('Concentration')}</div>
      </div>
      {[3, 5, 10, 15].map(interval => (
        <div
          key={interval}
          className={
            DL_SWITCH_CLASS_NAME +
            (showTopN && priceViewerTopN === interval ? ' checked' : '') +
            (showTopN ? '' : ' disabled')
          }
          onClick={wrapAnalytics(`topN-${interval}`, () =>
            dispatch(preferenceActions.setPriceViewerTopN(interval))
          )}
        >
          {interval}
        </div>
      ))}
    </div>
  );
};

export default ConcentrationSwitch;
